import { Reveal } from "./Reveal";
import { JOURNEY_STEPS } from "../data/content";

export const Journey = () => (
  <div className="relative">
    <div className="absolute left-0 right-0 top-10 hidden h-px bg-ink/10 lg:block" />
    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
      {JOURNEY_STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.1}>
          <div
            data-testid={`journey-step-${s.n}`}
            className="group relative h-full rounded-2xl border border-ink/10 bg-white p-6 transition-all duration-500 hover:-translate-y-1 hover:border-gold hover:shadow-lg"
          >
            <span className="font-display text-4xl font-semibold text-gold/60 transition-colors group-hover:text-gold">
              {s.n}
            </span>
            <h3 className="mt-4 font-display text-xl font-medium text-ink">{s.name}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/60">{s.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);
